import { combineReducers } from "redux";
import agendamento from "./modules/agendamentos/reducer";
import cliente from "./modules/cliente/reducer";
import admin from "./modules/admin/reducer";
import colaborador from "./modules/colaborador/reducer";
import servico from "./modules/servico/reducer";
import horario from "./modules/horario/reducer";
import Vans from "./modules/vans/reducer";
import reserva from "./modules/reservaCarro/reducer";

export default combineReducers({
    agendamento,
    cliente,
    colaborador,
    servico,
    horario,
    Vans,
    reserva,
    admin
})